/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Management_TitleInputs */

const en_inventory_management_title = /** @type {(inputs: Inventory_Management_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory Management`)
};

const es_inventory_management_title = /** @type {(inputs: Inventory_Management_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion de inventario`)
};

/**
* | output |
* | --- |
* | "Inventory Management" |
*
* @param {Inventory_Management_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_management_title = /** @type {((inputs?: Inventory_Management_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Management_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_management_title(inputs)
	return es_inventory_management_title(inputs)
});